import { SubscriptionPlanType } from '@/services/types'
import Vue, {PropType} from 'vue'

export const ISubscriptionPlanSelectProp = Vue.extend({
    props: {
        value: {
            type: String as PropType<SubscriptionPlanType>,
            required: true
        },
        onSelect: {
            type: Function as PropType<(selected: SubscriptionPlanType) => void>,
            required: true
        }
    }
})